import React, { memo, useEffect, useState } from "react"
import CardVod from "components/CardVod"
import Link from "next/link"
import TypeEvent from "utils/TypeEvent"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Navigation } from "swiper"
import CardShort from "components/CardShort"
// eslint-disable-next-line react/display-name
const SwiperShort = memo(({ name, events, id, type_block, display_type }) => {
  const [deVice, setDeVice] = useState("desktop")
  function onChangePerView() {
    switch (type_block) {
      case TypeEvent.SHORT:
        if (display_type === DisplayTypeScreenBlock.HORIZONTAL) {
          if (deVice === "mobile") {
            return 2.5
          } else if (deVice === "ipad") {
            return 4.5
          } else {
            return 5.35
          }
        } else {
          if (deVice === "mobile") {
            return 2.5
          } else if (deVice === "ipad") {
            return 4.5
          } else {
            return 6.2
          }
        }
      default:
        return 7
    }
  }

  function onChangePerGroup() {
    if (type_block === TypeEvent.SHORT) {
      if (display_type === DisplayTypeScreenBlock.HORIZONTAL) {
        if (deVice === "mobile") {
          return 1
        } else if (deVice === "ipad") {
          return 3
        } else {
          return 4
        }
      } else {
        if (deVice === "mobile") {
          return 2
        } else if (deVice === "ipad") {
          return 4
        } else {
          return 6
        }
      }
    }
  }

  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  })
  return (
    <div className="mb-4 md:mb-4 lg:mb-6 ">
      <h2 className="relative mb-2 md:mb-2 text-sm md:text-lg lg:text-xl font-semibold">
        <Link href={`/danh-muc/${id}`}>
          <div className="text-dark-100 flex items-center wapper_see_more">
            <span className="uppercase mr-4">{name}</span>{" "}
            <div className="text-primary-500 text-sm flex items-center see_more">
              <span>Xem thêm</span>
              {icSeemore}
            </div>
          </div>
        </Link>
      </h2>
      <div className="relative wapper__swiper__custom">
        <Swiper
          key="vod_item"
          slidesPerView={onChangePerView()}
          slidesPerGroup={onChangePerGroup()}
          spaceBetween={16}
          modules={[Navigation]}
          className={"swiper__short"}
          navigation={true}
        >
          {events?.length > 0 &&
            events?.map((item) => {
              return (
                <SwiperSlide key={item?.id} className="aspect-[9/16]">
                  <CardShort
                    {...item}
                    display_type={display_type}
                    hideText={display_type === DisplayTypeScreenBlock.HORIZONTAL ? false : true}
                    showTime={false}
                  />
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>
    </div>
  )
})

export default SwiperShort

const icSeemore = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 17L18 12L13 7" stroke="#66A7FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 17L11 12L6 7" stroke="#66A7FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
